<template>
  <div
    class="container"
  >
    <breadcrumb
      :items="links"
    />
  </div>
</template>
<script>
import ActiveObjectStore from 'mixins/ActiveObjectStore';
import Breadcrumb from 'components/Breadcrumb.vue';

export default {
  name: 'ObjectBreadcrumbs',
  components: {
    Breadcrumb,
  },
  mixins: [ActiveObjectStore],
  data() {
    return {
      buttonActive: true,
    };
  },
  computed: {
    links() {
      const { objectType, objectNumber, breadcrumb: storeBreadcrumbs } = this.objectData;
      const objectNumberShort = this.$t('object:objectNumberShort');
      const objectBreadcrumb = [{
        // used as a fallback option if there is no data about the type of the object
        name: `${objectType === null ? '' : this.$t(`object:${objectType}`)} ${this.$t(`object:${objectNumberShort}`)}  ${objectNumber}`,
        url: '',
      }];
      if (storeBreadcrumbs) return storeBreadcrumbs.concat(objectBreadcrumb).map((el) => ({ path: el.url, label: el.name }));
      return [];
    },
    classButton() {
      return ((this.buttonActive === true) ? 'd-md-none pointer' : 'd-none');
    },
    classLi() {
      return ((this.buttonActive === true) ? 'd-none d-md-block' : '');
    },
  },
  methods: {
    toggle() {
      this.buttonActive = !this.buttonActive;
    },

  },
};
</script>
